import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from '../../../../adapter-vue';
import { TUIStore, IMessageModel, TUIReportService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, parseTextAndValidateUrls } from '@tencentcloud/universal-api';
import { CUSTOM_BASIC_EMOJI_URL, CUSTOM_BASIC_EMOJI_URL_MAPPING } from '../../emoji-config';
import { isPC, isUniFrameWork } from '../../../../utils/env';

interface IProps {
  content: Record<string, any>;
  messageItem: IMessageModel;
  enableURLHighlight?: boolean;
}

interface TextItem {
  name: string;
  text: string;
  src?: string;
  type?: string;
  emojiKey?: string;
  url?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-text',
  props: {
    content: { default: () => ({}) },
    messageItem: { default: () => ({} as IMessageModel) },
    enableURLHighlight: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { content: Record<string, any>, messageItem: IMessageModel, enableURLHighlight: boolean }



const processedContent = ref<TextItem>([]);

watch(
  () => props.messageItem,
  (newValue: IMessageModel, oldValue: IMessageModel) => {
    if (newValue?.ID === oldValue?.ID) {
      return;
    }

    if(props.enableURLHighlight){
      TUIReportService.reportFeature(208);
    }

    if(props.messageItem.getMessageContent){
      processedContent.value =  props.messageItem.getMessageContent()?.text;
    } else {
      processedContent.value = TUIStore.getMessageModel(props.messageItem.ID)?.getMessageContent()?.text;
    }
    processedContent.value = processedContent.value || props.content?.text;

    if (!processedContent.value?.length) {
      processedContent.value = [];
      return;
    }

    processedContent.value = processedContent.value.map((item: TextItem) => {
      // handle custom emoji
      if (item.name === 'img' && item?.type === 'custom') {
        if (!CUSTOM_BASIC_EMOJI_URL) {
          console.warn('CUSTOM_BASIC_EMOJI_URL is required for custom emoji.');
          return item;
        }
        if (!item.emojiKey || !CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey]) {
          console.warn('emojiKey is required for custom emoji.');
          return item;
        }
        return {
          ...item,
          src: CUSTOM_BASIC_EMOJI_URL + CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey]
        };
      }

      // handle url
      if (props.enableURLHighlight && item.name === 'text' && item.text) {
        if(!parseTextAndValidateUrls){
          console.warn('parseTextAndValidateUrls not found. Please update @tencentcloud/universal-api to 2.3.7 or higher.');
          return item;
        }
        const segments = parseTextAndValidateUrls(item.text);
        if (segments.length) {
          return segments.map((segment)=>({
            name: segment.type,
            text: segment.text,
            url: segment.url,
          }));
        }
      }

      return item;
    })?.flat();
  },
  {
    deep: true,
    immediate: true,
  }
);

// Function to handle navigation
function navigateToUrl(url: string) {
  if (url) {
    if (isUniFrameWork) {
      // Use UniApp navigation
      TUIGlobal.navigateTo({
        url: `/pages/views/webview?url=${url}` // Assuming you have a webview page to handle external URLs
      });
    } else {
      // Use standard browser navigation
      TUIGlobal.open(url, '_blank');
    }
  }
}

return { __sfc: true,props, processedContent, navigateToUrl, isPC }
}

})